export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13')
];

export const server_loads = [0];

export const dictionary = {
		"/(header)": [5,[2]],
		"/(header)/(user)/admin": [6,[2,3,4]],
		"/(header)/(user)/admin/games": [7,[2,3,4]],
		"/(header)/(user)/admin/games/[gameId]": [8,[2,3,4]],
		"/(header)/(user)/admin/invites": [9,[2,3,4]],
		"/(header)/(user)/admin/users": [10,[2,3,4]],
		"/(header)/(user)/games": [11,[2,3]],
		"/(header)/(user)/games/[gameId]": [12,[2,3]],
		"/oauth2/[providerId]": [13]
	};

export const hooks = {
	handleError: (({ error }) => { console.error(error) }),
	
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));
export const encoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.encode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';